
/**
 * Template handler
 * 
 */
var plektemplate = {

    construct() {
        //Register the eventlistener

        jQuery(document).on("click", ".overlay-close-con .plek-button", (e) => {
            const overlay_id = jQuery(e.target).parent().data('overlay-id');
            plektemplate.remove_overlay(overlay_id);
        });

        jQuery(document).on("click", ".overlay-close-button", (e) => {
            const overlay_id = jQuery(e.target).data('overlay-id');
            plektemplate.remove_overlay(overlay_id);
        });

        jQuery(document).on("mouseover", ".spellchecker_content .spellchecker-added", (e) => {
            this.showSpellcheckerAction(e.currentTarget);
        });
        jQuery(document).on("mouseover", ".spellchecker_content .spellchecker-removed", (e) => {
            this.showSpellcheckerAction(e.currentTarget);
        });
        jQuery(document).on("click", ".spellchecker_content .action-popup div", (e) => {
            this.executeSpellcheckerAction(e.currentTarget);
        });

    },

    load_template(template, val_object) {
        var output = template;
        con(`${template}`);
        jQuery.each(val_object, function (key, val) {
            output = output.replace('%%' + key + '%%', val);
        });
        return output;
    },
    /**
     * Formats the band item for the band selection list.
     * @param {object} data The band preloader data
     * @returns 
     */
    load_band_item_template(data, percentage) {
        var flag = this.get_flag_image(data.flag);
        let band_playtime = (typeof data.timetable === 'object' && typeof data.timetable.playtime !== 'undefined') ? data.timetable.playtime : 0;
        let playtime_formated = (typeof data.timetable === 'object' && typeof data.timetable.playtime_formated !== 'undefined') ? data.timetable.playtime_formated : '0';
        let timestamp = (typeof data.timetable === 'object' && typeof data.timetable.timestamp !== 'undefined') ? data.timetable.timestamp : 0;
        let match = (!empty(percentage) && percentage === 150) ? 'exact-match-result' : '';
        return `<button type='button' class='item plek-add-item ${match}' 
        data-for='event-band-selection' data-type='event_band' data-id='${data.id}' 
        data-sort='${data.band_sort}' data-playtime='${band_playtime}' data-timestamp='${timestamp}'>
        <div class='title-container'>
            <div class='flag'>
                <img src="${flag}"/>
            </div>
            <div class='title-group'>
                <span class='item-title'>${data.name}</span>
                <div class='subtitle'>${data.genres}</div>
            </div>
        </div>
        <div class='button-container'>
            <div class='sort-button plek-button'><i class="fas fa-arrows-alt-v"></i></div>
            <div class='band-time plek-button'>
                <span class='time-label'><i class="far fa-clock"></i></span>
                <input class='band-time-input' type='datetime' name='band-time-${data.id}' id='band-time-${data.id}'value='${playtime_formated}'/>
            </div>
            <div class='remove-item plek-button'><i class="fas fa-times"></i></div>
        </div>
        </button>`;
    },
    load_venue_item_template(data) {
        return `<button type='button' class='item plek-add-item' data-for='event-venue-selection' data-type='event_venue' data-id='${data.id}'>
        <div class='title'>
        <span class='item-title'>${data.name}</span></div>
        <div class='subtitle'>${data.address}, ${data.zip} ${data.city}<span class='country'>${data.country}</span></div>
        </button>`;
    },
    load_organizer_item_template(data) {
        return `<button type='button' class='item plek-add-item' data-for='event-organizer-selection' data-type='event_organizer' data-id='${data.id}'>
        <div class='title'>
        <span class='item-title'>${data.name}</span>
        </div>
        <div class='subtitle'>
        <div class='web'>${data.web}</div>
        <div class='description'>${data.description}</div>
        </div>
        </button>`;
    },
    load_search_overlay_header(count, content = "") {
        var found = __('Items found:', 'plekvetica');
        return `<div class="overlay-header">
        ${content}
        <span class="count">${found} ${count}</span>
        </div>`;
    },
    get_template(selector) {
        return jQuery(selector).get(0).outerHTML;
    },
    /**
     * Shows the overlay with the given name or jQuery object
     * @param {string|jQuery} input - The name of the overlay or the jQuery object
     */
    show_overlay(input) {
        var id_name = jQuery(input).attr('name');
        if (typeof id_name === 'undefined') {
            id_name = input;
        }

        jQuery('#' + id_name + '_overlay').show();

        //Reposition of the content, if overlay_content exists
        jQuery('#' + id_name + '_overlay .overlay_content').css('margin-top', jQuery(document).scrollTop() + 100);

        //Set the Z index to position it on the top
        const visible_overlays = jQuery('.plek-overlay-container:visible').length;
        const base_z = this.get_highest_overlay_z_index();

        jQuery('#' + id_name + '_overlay .overlay_content').css('z-index', base_z + visible_overlays + 1);
        jQuery('#' + id_name + '_overlay .overlay_background').css('z-index', base_z + visible_overlays);


        window.plektemplate.activate_overlay_background(input);

    },

    /**
     * Retrieves the highest z-index value among all visible overlay contents.
     * Iterates through each visible overlay content element, checking its z-index,
     * and updates the `highest` variable if a greater z-index is found.
     * 
     * @returns {number} The highest z-index value found among visible overlay contents.
     */

    get_highest_overlay_z_index() {
        let highest = 0;
        jQuery('.plek-overlay-container:visible .overlay_content').each(function () {
            const element = jQuery(this);
            const z = parseInt(element.css('z-index'));
            if (z > highest) {
                highest = z;
            }
        });
        return highest;
    },
    hide_overlay(overlay_id = false) {
        if (overlay_id !== false) {
            if (jQuery('#' + overlay_id + '_overlay').hasClass('cannot-dismiss')) {
                console.log('User cannot hide overlay');
                return;
            }
            jQuery('#' + overlay_id + '_overlay').hide();
            window.plektemplate.deactivate_overlay_background(overlay_id);
            return;
        }
        jQuery('.plek-search-overlay').hide();
        jQuery('.plek-overlay-container').hide();
        window.plektemplate.deactivate_overlay_background();
    },

    activate_overlay_background(input) {
        var doc_height = jQuery(document).height();
        if (typeof input === 'object') {
            jQuery(input).css('z-index', 20);
            jQuery('.overlay_background').height(doc_height);
            jQuery('.overlay_background').click(function () {
                window.plektemplate.hide_overlay();
            });
        } else {
            //Input is string / ID of object
            jQuery('#' + input + '_overlay .overlay_background').height(doc_height);
            jQuery('#' + input + '_overlay .overlay_background').click(function () {
                window.plektemplate.hide_overlay(input);
            });
        }
    },
    deactivate_overlay_background(overlay_id = false) {
        if (overlay_id !== false) {
            jQuery('#' + overlay_id + '_overlay .overlay_background').height(0);
            jQuery('#' + overlay_id + '_overlay .overlay_background').off('click');
        }
        jQuery('.overlay_background').height(0);
        jQuery('.overlay_background').off('click');
    },

    prepare_data(object) {
        console.log(object);
        var ret = new Object();
        ret.id = object.data.id;
        ret.name = object.data.name;
        ret.class = object.class;
        ret.genres = (typeof object.data.id !== 'undefined') ? object.data.id : '';
        ret.flag = (typeof object.data.flag !== 'undefined') ? this.get_flag_image(object.data.flag) : '';
        return ret;
    },
    /**
     * Returns the URL of a flag image, given a ISO country code.
     * If the flag does not exist, an empty string is returned.
     *
     * @param {string} code ISO country code
     * @returns {string} The URL of the flag image
     */
    get_flag_image(code) {
        if (empty(code) || code.length < 1) {
            return "";
        }
        return plek_vars.plek_plugin_dir_url + 'images/flags/' + code.toLowerCase() + '.png'
    },

    get_item_to_add(data) {
        return `<div class='item plek-select-item' data-id='${data.id}' data-timestamp='${data.timestamp}' data-sort='${data.sort}'>
            <div class='title'>
            <span class='remove-item'><i class="fas fa-times"></i></span>
            <span class='item-title'>${data.html}</span>
            </div>
        </div>`;
    },

    /**
     * Registers a overlay. User show_overlay to display it.
     * 
     * @param {string} overlay_id The ID of the overlay
     * @param {string} content The content
     * @param {string} close_button_text Name of the close button. If empty, no close button will be displayed
     * @param {bool} user_can_dismiss Defines, if the user is able to dismiss the notice.
     */
    add_overlay(overlay_id, content = "", close_button_text = "", user_can_dismiss = true) {
        const close_button = (!empty(close_button_text) && user_can_dismiss === true) ? `<button class='plek-button'>${close_button_text}</button>` : "";
        const cannot_dismiss_class = (!user_can_dismiss) ? 'cannot-dismiss' : "";

        let overlay = `<div id='${overlay_id}_overlay' class='plek-overlay-container ${cannot_dismiss_class}' style='display:none;'>
        <div class='overlay_content'>
        ${content}
        <div class='overlay-close-con' data-overlay-id="${overlay_id}">${close_button}</div>
        </div>
        <div class='overlay_background'>
        </div>
        </div>`;
        jQuery('body').append(overlay);
    },

    /**
     * Removes all the overlays
     * 
     * @param {string} overlay_id The ID of the overlay. If set to false, all overlays will be removed
     * @returns void
     */
    remove_overlay(overlay_id = false) {
        if (overlay_id !== false) {
            jQuery('#' + overlay_id + '_overlay').remove();
            return;
        }
        jQuery('.plek-search-overlay').remove();
        jQuery('.plek-overlay-container').remove();
    },

    /**
     * Callback when the AJAX call for sending a message is successful.
     * If the message was sent (success === 'sent'), a success message is displayed.
     * If the message was previewed (success === 'preview'), the preview overlay is displayed.
     * 
     * @param {object} response The AJAX response object
     * @param {object} button The button which triggered the AJAX call
     * @returns void
     */
    onSendMessageSuccess(response, button) {

        if (plek_main.response_has_errors(response)) {
            plekerror.show_errors_from_response(response);
            return;
        }
        if (response.length === 0) {
            plekerror.display_error(__('Error', 'plekvetica'), __('Empty response from server', 'plekvetica'));
            return;
        }

        plektemplate.remove_overlay('email_preview');
        const success = plek_main.get_success_item_from_ajax_request(response);
        if (success !== 'preview') {
            plekerror.display_success(__('Message sent!', 'plekvetica'), success);
            return;
        }
        //Only if preview is requested
        if (typeof window.getUserSetting !== 'function') {
            //Workaround for the wp editor to work
            window.getUserSetting = function () { return ''; };
        }
        const email_preview = plek_main.get_success_item_from_ajax_request(response, 'content');
        plektemplate.add_overlay('email_preview', email_preview);
        plektemplate.show_overlay('email_preview');
        return;
    },

    /**
     * Processes the response from the spellchecker and displays the differences between the original 
     * and corrected text. Removes any existing spellchecker container from the DOM and checks for 
     * the availability of a 'Diff' plugin. If the plugin is unavailable, displays an error. Otherwise, 
     * calculates the word differences using the plugin and generates a visual representation of changes 
     * with added and removed text. If no changes are needed, displays a success message. Appends the 
     * spellchecker output to the button's parent element.
     * 
     * @param {Object} response - The response object from the spellchecker AJAX request.
     * @param {Object} button - The button element that triggered the spellchecker action.
     */
    onSpellcheckerSuccess(response, button) {
        let response_object = '';
        jQuery('.plek-spellchecker-container').remove();

        const input_id = jQuery(button).data('target');
        let original_text = plek_main.get_text_from_id('#' + input_id);
        let response_text = plek_main.get_success_item_from_ajax_request(response, 'response');

        if (typeof Diff === "undefined") {
            plekerror.display_error(__('Error', 'plekvetica'), __('Diff plugin not found', 'plekvetica'));
            return;
        }
        let diff = [];
        try {
            diff = Diff.diffWords(original_text, response_text);
        } catch (error) {
            plekerror.display_error(__('Error', 'plekvetica'), __('Error while comparing the spellchecked text', 'plekvetica'));
            console.log(error);
        }
        /*console.log('original_text');
        console.log(original_text);
        console.log('response_text');
        console.log(response_text);
        console.log(diff);
 */

        let changes = '';
        let change_index = 0;
        let contains_tags = false;
        diff.forEach(part => {
            change_index++;
            contains_tags = false;
            const tags = /<\/?|>/;
            if (tags.exec(part.value) !== null) {
                contains_tags = true;
            }

            const style = part.added ? 'added' : part.removed ? 'removed' : '';
            if (!empty(style) && !contains_tags) {
                part.change_index = change_index;
                //console.table(part);
                changes += `<span id='change-${change_index}' class='spellchecker-${style}'>${part.value}</span>`
            } else {
                if (contains_tags) {
                    //Only returns the text if there is nothing added. E.g. if it is the original text
                    if (part.added === false && part.removed === false || part.added === true && part.removed === false) {
                        changes += part.value;
                    }
                } else {
                    changes += part.value; //Just returns the text as it is.
                }
            }
        });

        if (original_text === response_text && diff.length <= 1) {
            plekerror.display_success(__('Yay!', 'plekvetica'), __(' No changes needed. Good job 🤘', 'plekvetica'));
            return;
        }
        const spellchecker_output = `<div class='plek-spellchecker-container' data-spellchecker-input-id="${input_id}">
        <div class='fixed_text'>
        <div class='buttons'>
        <button class='plek-button spellchecker_apply'><i class="fas fa-check"></i></button>
        <button class='plek-button-cancel spellchecker_cancel'><i class="fas fa-times"></i></button>
        </div>
        <div class='spellchecker_content'>
        ${changes}
        </div>
        </div>
        </div>`;
        jQuery(button).parent().append(spellchecker_output);
    },

    /**
     * Shows the spellchecker action popup, which has two buttons: 'Apply' and 'Cancel'
     * @param {string|jQuery} target - The target element to append the popup to
     */
    showSpellcheckerAction(target) {
        //Remove the previous popups
        jQuery('.plek-spellchecker-container .action-popup').remove();
        const target_id = target.id;
        jQuery(target).parent().append(`<div class="action-popup" data-target-id="${target_id}">
            <div class="add"><i class="fas fa-check"></i></div>
            <div class="remove"><i class="fas fa-times"></i></div>
            </div>`);

        //Position the popup
        jQuery(".action-popup").css("top", target.offsetTop - (jQuery(target).height() * 2));
        jQuery(".action-popup").css("left", target.offsetLeft);
    },

    /**
     * Executes the spellchecker action, either adding or removing the text from the DOM.
     * @param {string|jQuery} target - The target element to get the action from
     */
    executeSpellcheckerAction(target) {
        const action = jQuery(target).hasClass('add') ? 'add' : 'remove';
        const parent = jQuery(target).parent().parent(); //The item that triggered the popup
        const targetId = jQuery(target).parent().data("target-id");
        const targetClass = jQuery("#" + targetId)[0].classList[0];
        let sibling = "";
        let text = "";
        if (targetClass === 'spellchecker-removed') {
            sibling = jQuery("#" + targetId).next(".spellchecker-added");
        } else {
            sibling = jQuery("#" + targetId).prev(".spellchecker-removed");
        }

        if (action === 'add') {
            text = jQuery("#" + targetId).html();
        } else {
            text = sibling.html();
        }
        jQuery("#" + targetId).replaceWith(text);

        //Remove sibling and popup
        sibling.remove();
        jQuery('.plek-spellchecker-container .action-popup').remove();
    }

}

plektemplate.construct();